import React from 'react';

import { Button } from 'carbon-components-react';
import { ArrowRight16 } from '@carbon/icons-react';
import { useDeviceType } from 'customHooks/useDeviceType';

interface Props {
  responsesExpired: boolean;
  isLoading: boolean;
  onShowLual: () => void;
}

export const LookUpAndLiveButton = (props: Props) => {
  const { isMobileOrTablet } = useDeviceType();
  const { isLoading, onShowLual } = props;

  return (
    <div
      className="get-plans-actions-lual"
      style={isMobileOrTablet ? { marginTop: '0px' } : {}}
    >
      {!isLoading && (
        <Button
          kind={'secondary'}
          className="open-in-lual-button"
          renderIcon={isMobileOrTablet ? null : ArrowRight16}
          onClick={onShowLual}
          data-testid="show-lual-button"
        >
          {isMobileOrTablet ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <div>Look up and Live</div>
                <div>
                  <ArrowRight16
                    height={isMobileOrTablet ? 20 : 16}
                    width={isMobileOrTablet ? 20 : 16}
                  />
                </div>
              </div>
              <div style={{ fontSize: '12px', fontWeight: 'normal' }}>
                View your job site on Look up and Live (LUAL) to check for
                above-ground assets such as powerlines and other infrastructure.
              </div>
            </div>
          ) : (
            <>Look up and Live</>
          )}
        </Button>
      )}
    </div>
  );
};

export default LookUpAndLiveButton;
